<template>
<!-- 算力消费行业 玫瑰图 -->
<div class="chart-rose"></div>
</template>

<script>
import * as echarts from 'echarts'
import { merge } from 'lodash'
import chartConfig from '@/utils/chartConfig'

const colors = ['#259fff', '#f36067', '#ffc00e', '#c793f2', '#7d63ee', '#45f8ff', '#5fd3fd']

export default {
  name: 'chart-rose',
  props: {
    data: Array,
    pie: Boolean
  },
  watch: {
    data: {
      deep: true,
      handler () {
        this.update()
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const chart = echarts.init(this.$el)
      window.addEventListener('resize', chart.resize)
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', chart.resize)
        chart.dispose()
      })
      this.chart = chart
      this.update()
    },
    update () {
      const { data, pie } = this
      if (!data || !data.length) return
      const option = {
        tooltip: Object.assign({}, chartConfig.tooltip, { trigger: 'item' }),
        legend: {
          orient: 'vertical',
          itemGap: 15,
          right: 20,
          top:0,
          bottom: 5,
          itemHeight: 12,
          itemWidth: 12,
          textStyle: {
             color: "#fff",
              rich: {
                name: {
                  fontSize:12,
                  color: "#fff",
                  padding: [0, 12, 0, 0],
                  fontFamily: 'OPPOSans R'
                },
                num: {
                  fontSize: 14,
                  fontWeight: 500,
                  padding: [0, 0, 0, 0],
                  color: "#fff"
                }
              }
          },
          formatter(name) {
              let tarValue;
              for (let i = 0; i < data.length; i++) { 
                  if (data[i].name == name) {
                    tarValue = data[i].value
                  }
              }
              return `{name|${name}}{num|${tarValue}%}`;
          }
        },
        series: [{
          type: 'pie',
          radius: [pie ? 0 : '20%', '100%'],
          center: ['27%', '40%'],
          roseType: pie ? null : 'area',
          label: {
            show: false 
          },
          itemStyle: {
            color: ({ dataIndex }) => {
              return data[dataIndex].color || colors[dataIndex] || colors[dataIndex.length - 1]
            }
          },
          data: data.map(item => {
            return {
              name: item.name,
              value: item.value,
            }
          })
        }]
      }
      this.chart.setOption(option)
    }
  }
}
</script>
